import configState from '../state/config';

export default function configReducer(state = configState, action) {
  switch (action.type) {
    default:
      return state;
  }
}